import { dateNow, faro, genShortID } from '@grafana/faro-core';
// TODO: add tests
export const STORAGE_KEY = '__FARO_SESSION__';
export const SESSION_EXPIRATION_TIME = 4 * 60 * 60 * 1000; // hrs
export const SESSION_INACTIVITY_TIME = 15 * 60 * 1000; // minutes
export const STORAGE_UPDATE_DELAY = 1 * 1000; // seconds
export const MAX_SESSION_PERSISTENCE_TIME_BUFFER = 5 * 60 * 1000;
export const MAX_SESSION_PERSISTENCE_TIME = SESSION_EXPIRATION_TIME + MAX_SESSION_PERSISTENCE_TIME_BUFFER;
export function createUserSessionObject(sessionId) {
    const now = dateNow();
    return {
        sessionId: sessionId !== null && sessionId !== void 0 ? sessionId : genShortID(),
        lastActivity: now,
        started: now,
    };
}
export function isUserSessionValid(session) {
    if (session == null) {
        return false;
    }
    const now = dateNow();
    const lifetimeValid = now - session.started < SESSION_EXPIRATION_TIME;
    if (!lifetimeValid) {
        return false;
    }
    const inactivityPeriodValid = now - session.lastActivity < SESSION_INACTIVITY_TIME;
    return inactivityPeriodValid;
}
export function getUserSessionUpdater({ fetchUserSession, storeUserSession }) {
    return function updateSession() {
        var _a, _b, _c, _d;
        if (!fetchUserSession || !storeUserSession) {
            return;
        }
        const sessionFromStorage = fetchUserSession();
        if (isUserSessionValid(sessionFromStorage)) {
            storeUserSession(Object.assign(Object.assign({}, sessionFromStorage), { lastActivity: dateNow() }));
        }
        else {
            let newSession = addSessionMetadataToNextSession(createUserSessionObject(), sessionFromStorage);
            storeUserSession(newSession);
            (_a = faro.api) === null || _a === void 0 ? void 0 : _a.setSession(newSession.sessionMeta);
            (_c = (_b = faro.config.experimentalSessions) === null || _b === void 0 ? void 0 : _b.onSessionChange) === null || _c === void 0 ? void 0 : _c.call(_b, (_d = sessionFromStorage === null || sessionFromStorage === void 0 ? void 0 : sessionFromStorage.sessionMeta) !== null && _d !== void 0 ? _d : null, newSession.sessionMeta);
        }
    };
}
export function addSessionMetadataToNextSession(newSession, previousSession) {
    var _a;
    const sessionWithMeta = Object.assign(Object.assign({}, newSession), { sessionMeta: {
            id: newSession.sessionId,
        } });
    const metaAttributes = (_a = faro.metas.value.session) === null || _a === void 0 ? void 0 : _a.attributes;
    if (metaAttributes || previousSession != null) {
        sessionWithMeta.sessionMeta.attributes = Object.assign(Object.assign({}, (metaAttributes !== null && metaAttributes !== void 0 ? metaAttributes : {})), (previousSession != null ? { previousSession: previousSession.sessionId } : {}));
    }
    return sessionWithMeta;
}
//# sourceMappingURL=sessionManagerUtils.js.map